import styles from "./analytics-table.module.css"

export default function BestSellingProducts({ products }) {
  return (
    <div className={styles.tableContainer}>
      <h2>Best Selling Products</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Product</th>
              <th>Quantity</th>
              <th>Revenue</th>
            </tr>
          </thead>
          <tbody>
            {products?.map((product, index) => (
              <tr key={index}>
                <td>{product._id.name}</td>
                <td>{product.totalQuantity}</td>
                <td>₹{product.totalRevenue.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
